import { useEffect } from 'react'

import { useSession } from '@/entities/session'

import { mindBoxSDK } from '@/shared/integrations/mindBox'
import { useCurrentCategory } from '@/shared/lib/hooks/useCurrentCategory'
import { waitForCookie } from '@/shared/lib/utils/cookies/wait-for-cookie'
import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'

export const MindboxCatalogPageView = () => {
	const { currentCategory } = useCurrentCategory()
	const { currentSession } = useSession()

	useEffect(() => {
		if (!currentCategory?.id) return
		const userPhone = getPhoneFromJwtToken(currentSession?.token)
		waitForCookie(`mindboxDeviceUUID`)
			.then(() => mindBoxSDK.sendCategoryPageViewEvent(currentCategory.id, userPhone))
			.catch(err => console.warn(err))
	}, [currentCategory.code, currentCategory.id, currentSession?.token])

	return <></>
}
